// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"5c5317b3","769":"d01f3eba"}[chunkId] + ".chunk.css";
};